import { render, staticRenderFns } from "./map-point.vue?vue&type=template&id=a40769dc&"
import script from "./map-point.vue?vue&type=script&lang=js&"
export * from "./map-point.vue?vue&type=script&lang=js&"
import style0 from "./map-point.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports